import { closeModal, openModal } from 'shared/utils'
import { T, __ } from 'translations/i18n'
import SelectLotsModal from '../../components/modals/SelectLotsModal'
import React from 'react'
import { Box, Button, Spacer, TextBox } from '../../components'

export default class QualityProviderNew {

  static showLotsModal = async (modalId: string, options: any[], serieCode?: string) => {
    return new Promise((resolve) => {
      openModal({
        id: modalId,
        body: (
          <SelectLotsModal
            modalId={modalId}
            title={__(T.misc.confirmed_lots)}
            visible
            options={options ?? []}
            onSelect={(items) => {
              resolve(items)
              closeModal(modalId)
            }}
            lotCode="code"
            date="creationDate"
            serie={serieCode ?? ''}
            onClose={() => {
              closeModal(modalId)
            }}
          />
        ),
      })
    })
  }

  static renderScartoModal = (setState: (showScartoModal: boolean) => void, scartoItem: (reversible?: boolean) => Promise<void>) => {
    return (
      <Box>
        <TextBox text={__(T.messages.select_discard_type)} type="error" />
        <Box row mt={15} center>
          <Button
            variant="default"
            title={__(T.misc.cancel)}
            onClick={() => {
              return setState(false)
            }}
          />
          <Spacer />
          <Button title={__(T.placeholder.reversible)} onClick={scartoItem} />
          <Spacer />
          <Button title={__(T.placeholder.irreversible)} onClick={() => scartoItem(false)} />
        </Box>
      </Box>
    )
  }

}
